// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPrescriberResult {
    static getAttributeTypeMap() {
        return MedicalBiPrescriberResult.attributeTypeMap;
    }
}
MedicalBiPrescriberResult.discriminator = undefined;
MedicalBiPrescriberResult.additionalProperties = false;
MedicalBiPrescriberResult.attributeTypeMap = [
    {
        "name": "inNetwork",
        "baseName": "inNetwork",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPrescriberResult.js.map